<template>
  <img
    src="https://static.wangsu.com/lib/images/status/v1/no-open.min.svg"
    alt="no-open"
  />
</template>
<script setup lang="ts">
import { defineComponent } from 'vue'

defineComponent({
  name: 'ElResultIconNoOpen',
})
</script>
